export default "__VITE_ASSET__Bcm9Dgdd__"